export const BASE_URL = 'https://www.worldmapgenerator.com'
export const BASE_URL_WITH_TRAILING_SLASH = `${BASE_URL}/`
export const SHARING_IMAGE_URL = `${BASE_URL}/share.jpg`
